var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04066 1.96087H11.9653C11.9291 1.45176 11.6378 1.17883 11.08 1.17883H4.92591C4.36816 1.17883 4.07713 1.45176 4.04066 1.96087ZM2.8522 3.64033H13.1597C13.0689 3.08879 12.8019 2.78559 12.1958 2.78559H3.81042C3.20403 2.78559 2.94301 3.08879 2.8522 3.64033ZM3.40426 14.8212H12.6022C13.8633 14.8212 14.5 14.1905 14.5 12.9415V6.50202C14.5 5.25304 13.8636 4.62234 12.6022 4.62234H3.404C2.13691 4.62234 1.5 5.24683 1.5 6.50202V12.941C1.5 14.1902 2.13717 14.8212 3.40426 14.8212ZM3.42211 13.8443C2.81599 13.8443 2.47632 13.5168 2.47632 12.8864V6.55066C2.47632 5.92022 2.81599 5.59866 3.42237 5.59866H12.5838C13.184 5.59866 13.5234 5.92022 13.5234 6.55066V12.8869C13.5234 13.5173 13.184 13.8449 12.5838 13.8449L3.42211 13.8443Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsThree);
export default __webpack_public_path__ + "static/media/cardsThree.f7d1225b28b705ddfb60ab5452ee1859.svg";
export { ForwardRef as ReactComponent };